{
  "info": "Tiedot",
  "negative": "Virhe",
  "notice": "Varoitus",
  "positive": "Onnistui"
}
